import { createClient } from '@supabase/supabase-js'

// Получите эти значения из Supabase Dashboard:
// Settings → API → Project URL и anon public key
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || ''
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || ''

// Детальное логирование для отладки
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Supabase credentials are missing!')
  console.error('REACT_APP_SUPABASE_URL:', supabaseUrl ? '✅ Set' : '❌ Missing')
  console.error('REACT_APP_SUPABASE_ANON_KEY:', supabaseAnonKey ? '✅ Set' : '❌ Missing')
  console.error('All env vars:', Object.keys(process.env).filter(k => k.startsWith('REACT_APP_')))
} else {
  console.log('✅ Supabase credentials loaded successfully')
  console.log('Supabase URL:', supabaseUrl.substring(0, 30) + '...')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Вспомогательные функции для работы с данными

/**
 * Получить текущего пользователя
 */
export const getCurrentUser = async () => {
  const { data: { user } } = await supabase.auth.getUser()
  if (!user) return null
  
  // Пробуем teachers (для преподавателей)
  const { data: teacherData, error: teacherError } = await supabase
    .from('teachers')
    .select('*')
    .eq('auth_user_id', user.id)
    .maybeSingle()
  
  if (!teacherError && teacherData) {
    return {
      ...teacherData,
      id: teacherData.auth_user_id,
      role: 'teacher'
    }
  }
  
  // Пробуем students (для студентов)
  const { data: studentData, error: studentError } = await supabase
    .from('students')
    .select('*')
    .eq('user_account_id', user.id)
    .single()
  
  if (!studentError && studentData) {
    return {
      ...studentData,
      id: user.id,
      role: 'student'
    }
  }
  
  return null
}

/**
 * Выйти из системы
 */
export const signOut = async () => {
  console.log('signOut function called');
  
  try {
    const { error } = await supabase.auth.signOut()
    if (error) {
      console.error('Error signing out from Supabase Auth:', error)
      // Не выбрасываем ошибку, чтобы не блокировать процесс выхода
    } else {
      console.log('Supabase Auth signOut successful');
    }
  } catch (error) {
    console.error('Exception during Supabase signOut:', error);
    // Продолжаем выполнение
  }
  
  // Всегда очищаем localStorage, даже если была ошибка
  console.log('Clearing localStorage in signOut function');
  localStorage.removeItem('currentUser')
  localStorage.removeItem('isAuthenticated')
  
  console.log('signOut function completed');
}

